import React from 'react';

import styled from 'styled-components';
import { PropTypes } from 'prop-types';

const List = styled.ul`
  list-style: none;
  text-align: center;
  padding: 0;

  li {
    font-size: 14px;
    height: 24px;

    a {
      text-decoration: none;
      color: ${({ theme }) => `${theme.colors.primary.purple}`};
    }

    a:hover {
      text-decoration: underline;
    }

    :nth-child(1) {
      display: none;
    }
  }

  @media ${({ theme }) => `${theme.breakpoints.tabletMin}`} {
    display: flex;
    justify-content: space-between;

    li {
      height: initial;
      margin-left: 13px;
    }
  }

  @media ${({ theme }) => `${theme.breakpoints.desktop}`} {
    li {
      :nth-child(1) {
        display: block;
        margin-left: 0;
      }
    }
  }
`;

export default function UsefullLinks({ list }) {
  return (
    <List>
      <li key={list.nav.length}>
        <b>{list.title}</b>
      </li>
      {list.nav?.map((item, key) => (
        <li key={key}>
          {item.link && (
            <a href={item.link} target="_blank" rel="noreferrer">
              {item.label}
            </a>
          )}
        </li>
      ))}
    </List>
  );
}

UsefullLinks.displayName = 'UsefullLinks';

UsefullLinks.propTypes = {
  list: PropTypes.arrayOf({
    title: PropTypes.string,
    link: PropTypes.string
  })
};

UsefullLinks.defaultProps = {
  list: undefined
};
